import { render, staticRenderFns } from "./PrimaryOutlinedButton.vue?vue&type=template&id=b4871dac&"
import script from "./PrimaryOutlinedButton.vue?vue&type=script&lang=js&"
export * from "./PrimaryOutlinedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports